import { useSelector } from 'react-redux'

import {
  selectTagOptionsData,
  selectTagOptionsFetched
} from 'redux/selectors/TagOptions'

export const useTagOptionsData = () => {
  return useSelector(selectTagOptionsData)
}

export const useTagOptionsFetched = () => {
  return useSelector(selectTagOptionsFetched)
}
